import { render, staticRenderFns } from "./ModalRegulamentos.vue?vue&type=template&id=5394e83c&scoped=true&lang=pug"
import script from "./ModalRegulamentos.vue?vue&type=script&lang=js"
export * from "./ModalRegulamentos.vue?vue&type=script&lang=js"
import style0 from "./ModalRegulamentos.vue?vue&type=style&index=0&id=5394e83c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394e83c",
  null
  
)

export default component.exports